import type { ReactNode } from 'react';

import { Icon } from './Icon';

export function EmptyState({ icon, title, body, action }: { icon: string; title: string; body: string; action?: ReactNode }) {
  return (
    <section className="empty-state">
      <span className="empty-icon"><Icon name={icon} size={30} /></span>
      <h2>{title}</h2>
      <p>{body}</p>
      {action}
    </section>
  );
}
